import React from "react";
import AccountInput from "../components/form/AccountInput";
import MobileCodeInput from "../components/form/MobileCodeInput";
import LoginDuration from "../components/form/LoginDuration";
import LoginButton from "../components/form/LoginButton";
import LoginRedirect from "../components/form/LoginRedirect";
import Utils from "../utils/Utils";
import {Alert, Modal} from "antd";
import ForceLogin from "./ForceLogin";
import "./MobileCodeLoginStyle.less";
import AlertPlaceholder from "../components/form/AlertPlaceholder";
import {connect} from "react-redux";
import Maps from "../redux/Maps";

class MobileCodeLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            captcha: {
                instance: null,
                status: "init",
                token: null,
            },
            message: {
                type: "",
                message: ""
            },
            accountValue: '',
            accountError: '',
            codeValue: '',
            codeError: '',
            codeText: '',
            codeCountdown: -1,
            codeLoading: false,
            loginDuration: false,
            loginButton: {
                loading: false
            },
            modal: {
                name: "",
                mobile: "",
                token: ""
            }
        };
    }

    componentDidMount() {
        let loginMobile = sessionStorage.getItem('loginMobile')
        if (loginMobile) {
            this.setState({
                accountValue: loginMobile,
                accountError: ''
            })
        }
        if (this.props.loginConfig.captcha) {
            const that = this;
            const captchaState = this.state.captcha;
            captchaState.instance = this.props.loginConfig.captcha.new({
                groupCode: this.props.loginConfig.group_code,
                vid: this.props.loginConfig.vaptcha_id,
                onSuccess: function (token) {
                    that.sendMobileCode(token);
                }
            });
            this.setState({
                captcha: captchaState
            })
        }
    }

    componentWillUnmount() {
        if (this.state.codeCountdown !== -1) {
            this.setState({
                codeCountdown: -1
            })
        }
        if (this.props.loginConfig.captcha) {
            this.state.captcha.instance.destroy()
        }
    }

    changeLoginType = (event, loginType) => {
        if (typeof event == 'string') {
            loginType = event
        }
        this.props.changeLoginType(loginType ? loginType : "accountPasswordLogin");
    }

    handleAccountOnBlur(event) {
        let accountError = ''
        let inputValue = event.target.value ? event.target.value.trim() : "";
        if (inputValue === "") {
            accountError = "请输入登录手机号";
        } else {
            if (!Utils.isPhoneAvailable(inputValue)) {
                accountError = '登录手机号格式错误'
                inputValue = ''
            }
        }
        this.setState({
            accountError: accountError
        })
        sessionStorage.setItem('loginMobile', inputValue)
    }

    handleAccountOnChange(event) {
        let accountValue = event.target.value
        let accountError = ''
        if (!accountValue) {
            accountError = "请输入登录手机号";
        }
        this.setState({
            accountValue: accountValue,
            accountError: accountError
        })
    }

    codeTimeCountDown() {
        let codeCountdown = this.state.codeCountdown;
        if (codeCountdown === -1) {
            codeCountdown = 60;
        } else {
            codeCountdown--;
        }
        this.setState({
            codeCountdown: codeCountdown
        });
        if (codeCountdown !== -1) {
            const that = this;
            setTimeout(function () {
                that.codeTimeCountDown();
            }, 1000);
        }
    }

    handleCodeButtonOnClick() {
        if (this.state.codeCountdown !== -1) {
            Modal.warning({
                content: "操作太频繁，请稍后再试！",
                okText: "确定"
            })
            return;
        }
        if (!this.state.accountValue) {
            this.setState({
                accountValue: this.state.accountValue,
                accountError: "请输入登录手机号"
            })
            return;
        }
        if (!Utils.isPhoneAvailable(this.state.accountValue)) {
            this.setState({
                accountError: "登录手机号格式错误"
            })
            return;
        }
        if (this.state.captcha.instance) {
            this.state.captcha.instance.verify();
        } else {
            this.sendMobileCode();
        }
    }

    handleCodeOnBlur(event) {
        let inputValue = event.target.value ? event.target.value.trim() : "";
        if (inputValue === "") {
            this.setState({
                codeError: '请输入短信验证码'
            });
        }
    }

    handleCodeOnChange(event) {
        let inputValue = event.target.value;
        let codeError = ''
        if (!inputValue) {
            codeError = "请输入短信验证码";
        }
        this.setState({
            codeValue: inputValue,
            codeError: codeError
        })
    }

    handleDurationOnChange(event) {
        const loginDuration = this.state.loginDuration;
        this.setState({
            loginDuration: loginDuration ? false : true
        })
    }

    sendMobileCode(token) {
        const that = this;
        this.setState({
            codeLoading: true
        });
        Utils.sendMobileCodeMessage({
            user_mobile: that.state.accountValue,
            group_code: that.props.loginConfig.group_code,
            use_type: "cmc_mob_login",
            captcha_drive: that.props.loginConfig.captcha_drive,
            validate: token
        }, function (result) {
            console.log(result);
            if (result.data.code === 10000) {
                that.setState({
                    codeLoading: false,
                    codeText: '短信验证码已发送成功',
                    codeCountdown: -1,
                    codeError: ''
                })
                that.codeTimeCountDown();
            } else {
                if (that.state.captcha.instance) {
                    that.state.captcha.instance.reset();
                }
                that.setState({
                    codeLoading: false,
                    codeText: '',
                    codeCountdown: -1,
                    codeError: result.data.message ? result.data.message : "短信验证码发送失败，请稍后重试"
                })
            }
        })
    }

    submitForm(event) {
        event.stopPropagation();
        event.preventDefault();
        if (!this.state.accountValue) {
            this.setState({
                accountError: "请输入登录手机号"
            })
            return;
        }
        if (!Utils.isPhoneAvailable(this.state.accountValue)) {
            this.setState({
                accountError: "登录手机号格式错误"
            })
            return;
        }
        if (!this.state.codeValue) {
            this.setState({
                codeError: "请输入短信验证码"
            })
            return;
        }
        if (this.state.codeError) {
            return;
        }
        this.login();
    }

    login() {
        this.setState({
            loginButton: {
                loading: true
            }
        });
        const loginData = {
            user_mobile: this.state.accountValue,
            group_code: this.props.loginConfig.group_code,
            msg_pwd: this.state.codeValue,
            login_type: "MUCode",
            login_mode: 1
        };
        if (this.state.loginDuration) {
            loginData["login_timeout"] = window.configs.login_duration;
        }
        loginData["captcha_drive"] = "false";
        loginData["validate"] = "";
        let loginUrl = window.configs.local_login_url;
        if (this.props.loginConfig.multi_tenant_login) {
            loginUrl = window.configs.multi_tenant_login_url;
            loginData['login_type'] = 'mobile_code';
        }
        if (this.props.loginConfig.login_from === "oauth-login") {
            loginData["service_key"] = this.props.loginConfig.service_key;
            loginData["successback"] = this.props.loginConfig.successback;
            loginUrl = window.configs.oauth_login_url;
        }
        const that = this;
        Utils.postLoginForm(loginData, loginUrl, function (result) {
            console.log(result);
            switch (result.data.code) {
                case 10000:
                case 20000:
                    Utils.loginSuccess(result.data.data.successback)
                    break;
                case 99508:
                    if (that.state.captcha.instance) {
                        that.state.captcha.instance.reset();
                    }
                    that.setState({
                        loginButton: {
                            loading: false
                        },
                        accountError: " ",
                        codeError: '手机号或验证码错误'
                    });
                    break;
                case 99815:
                    //需要修改密码
                    that.changeLoginType("ResetPassword");
                    break;
                default:
                    if (that.state.captcha.instance) {
                        that.state.captcha.instance.reset();
                    }
                    that.setState({
                        loginButton: {
                            loading: false
                        },
                        accountError: " ",
                        codeError: '手机号或验证码错误'
                    });
            }
        });
    }

    modalHandleOk() {
    }

    modalHandleCancel() {
        this.setState({
            loginButton: {
                loading: false
            },
            modal: {
                name: "",
                mobile: "",
                token: ""
            }
        });
    }

    closeAlert = () => {
        this.setState({
            message: {
                message: ''
            }
        })
    }

    render() {
        let ErrorBox = null;
        if (this.state.message.message) {
            ErrorBox = <Alert message={this.state.message.message} description={this.state.message.description}
                              type={this.state.message.type} showIcon banner closable afterClose={this.closeAlert}/>
        } else {
            ErrorBox = <AlertPlaceholder/>
        }
        let modalAlert = "";
        if (this.state.modal.name === "ForceLogin") {
            modalAlert = <ForceLogin {...this.state.modal} onOk={this.modalHandleOk.bind(this)}
                                     onCancel={this.modalHandleCancel.bind(this)}></ForceLogin>
        }
        return (
            <div className="login-form mobile-login-form">
                <div className="top-type"><img src={process.env.PUBLIC_URL + "/qrcode.png"} alt="qrcode"/></div>
                <div className="login-type">
                    <button className="active">手机号登录</button>
                    <button onClick={this.changeLoginType}>用户名登录</button>
                </div>
                <div className="mobile-code-login-box">
                    {ErrorBox}
                    {modalAlert}
                    <form onSubmit={this.submitForm.bind(this)}>
                        <AccountInput name="mc-ai" placeholder="请输入登录手机号" value={this.state.accountValue}
                                      error={this.state.accountError}
                                      autoComplete="new-password" onChange={this.handleAccountOnChange.bind(this)}
                                      onBlur={this.handleAccountOnBlur.bind(this)}/>
                        <MobileCodeInput name="mc-mc"
                                         value={this.state.codeValue}
                                         countdown={this.state.codeCountdown}
                                         error={this.state.codeError}
                                         autoComplete="off"
                                         text={this.state.codeText}
                                         loading={this.state.codeLoading}
                                         onChange={this.handleCodeOnChange.bind(this)}
                                         onBlur={this.handleCodeOnBlur.bind(this)}
                                         sendCode={this.handleCodeButtonOnClick.bind(this)}/>
                        <LoginDuration onChange={this.handleDurationOnChange.bind(this)}
                                       checked={this.state.loginDuration}/>
                        <LoginButton htmlType="submit" name="submit" text="登录"
                                     loading={this.state.loginButton.loading}/>
                        <LoginRedirect resetPassword={this.props.loginConfig.reset_password === "1"}
                                       register={this.props.loginConfig.open_register === "1"} passwordLogin/>
                    </form>
                </div>
            </div>
        );
    }
}

export default connect(null, Maps.mapLoginTypeDispatchToProps)(MobileCodeLogin);